import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { EventsService } from '@services/events.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'loading-overlay',
	styleUrls: ['./_loading-overlay.scss'],
	template: `
        @if (showLoader) {
          <div #contentPlaceholder class="loading-overlay" [ngClass]="{'show-loader': showLoader, 'not-show-loader': !showLoader}">
            <img class="loader" [src]="'/assets/animations/Framespinner.gif'" />
          </div>
        }
        `,
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CommonModule]
})
export class LoadingOverlayComponent implements OnDestroy {

	public showLoader: boolean = false;

	private subscription: Subscription;

	constructor(
		private eventsService: EventsService,
		private changeDetector: ChangeDetectorRef
	) {
		this.subscription = this.eventsService.showLoadingOverlay$.subscribe((mode) => {
			if (mode !== null) {
				this.showLoader = mode;
				this.changeDetector.detectChanges(); //necessary when error occurs
			}
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

}
